export const FLUX_VERSION = '1.4.0';
